/* Esthétique v2: Estúdio de Marca (UI Lehmann, 09/10/2026). JS puro, sem biblioteca, sem rede.
   Porta (Facial/Corporal) muda a paleta da página via atributo no root; nome, cor e fonte recolorem a mesa ao vivo;
   "Levar meu kit" desenha um PNG no canvas, no próprio aparelho. Nada é enviado nem guardado (só sessionStorage 'ev2s-pre', da abertura).
   Texto do visitante entra sempre por textContent (nunca innerHTML). Movimento reduzido: estado final, sem animação.
   Contrato: theme-v2-docs/UI-CONTRATO-MOTION.md. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('ev2s-js');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  function qa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  var EASE = 'cubic-bezier(.23,1,.32,1)';

  /* ---------- Abertura: o CSS faz tudo em ~1,15 s; aqui só se lembra que já passou ---------- */
  if (root.classList.contains('ev2s-pre')) {
    try { sessionStorage.setItem('ev2s-pre', '1'); } catch (e) {}
    setTimeout(function () { root.classList.remove('ev2s-pre'); }, 1250);
  }

  var app = d.querySelector('[data-ev2s]');
  if (app) { try { studio(app); } catch (err) { /* qualquer falha deixa a mesa estática */ } }
  initCursor();

  function studio(app) {
    var desk = app.querySelector('[data-ev2s-desk]');
    var nameIn = app.querySelector('[data-ev2s-name]');
    var colorName = app.querySelector('[data-ev2s-colorname]');
    var form = app.querySelector('[data-ev2s-form]');
    if (!desk || !nameIn || !form) return;
    var S = { door: 'facial', name: '', font: 'classica', color: 'rose', main: '#F4ACB8', deep: '#8E2F48', cname: 'Rosa antiga' };
    var DOORS = { facial: { tag: 'Estética facial', paper: '#FFF8F4', label: 'facial' }, corporal: { tag: 'Estética corporal', paper: '#F4F8F5', label: 'corporal' } };
    var lastPt = null, lastPtAt = 0;

    function centerOf(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
    app.addEventListener('pointerdown', function (e) { lastPt = { x: e.clientX, y: e.clientY }; lastPtAt = Date.now(); }, true);
    function origin(fallbackEl) { return lastPt && Date.now() - lastPtAt < 800 ? lastPt : centerOf(fallbackEl); }

    /* ---------- Texto: nome, monograma, descrição acessível ---------- */
    function clean(v) {
      var a = Array.from(String(v).replace(/[\u0000-\u001f\u007f<>​-‏‪-‮⁦-⁩﻿]/g, ' ').replace(/\s+/g, ' ').replace(/^\s+/, ''));
      return a.slice(0, 32).join('');
    }
    function shown() { var n = S.name.trim(); return n || 'Sua clínica'; }
    function mono() { var n = S.name.trim(); var c = Array.from(n)[0]; return c ? c.toLocaleUpperCase('pt-BR') : 'S'; }
    function paintText() {
      var n = shown(), m = mono();
      qa('[data-name]', desk).forEach(function (el) { el.textContent = n; });
      qa('[data-mono]', desk).forEach(function (el) { el.textContent = m; });
      desk.setAttribute('aria-label', 'Prévia da mesa de papelaria: ficha clínica, receituário, envelope e cartão de visita com o nome ' + n + ', porta ' + DOORS[S.door].label + ', cor ' + S.cname + ', fonte ' + (S.font === 'moderna' ? 'moderna' : 'clássica') + '.');
    }
    nameIn.addEventListener('input', function () {
      var v = clean(nameIn.value);
      if (v !== nameIn.value) nameIn.value = v;
      S.name = v; paintText();
    });

    /* ---------- Montagem em sequência ---------- */
    var bt = 0;
    function build() {
      if (reduce) return;
      desk.classList.remove('is-building'); void desk.offsetWidth; desk.classList.add('is-building');
      clearTimeout(bt); bt = setTimeout(function () { desk.classList.remove('is-building'); }, 1800);
    }
    desk.classList.add('is-live');
    if (!reduce && 'IntersectionObserver' in window) {
      desk.classList.add('is-wait');
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () { desk.classList.remove('is-wait'); build(); }, root.classList.contains('ev2s-pre') ? 950 : 80);
      }, { threshold: 0.2 });
      io.observe(desk);
      setTimeout(function () { desk.classList.remove('is-wait'); }, 6000); // rede de segurança
    }

    /* ---------- Porta: paleta, textura e peças da página inteira (variável no root) ---------- */
    function applyDoor(door) {
      S.door = door;
      root.setAttribute('data-ev2-door', door);
      desk.setAttribute('data-door', door);
      var t = desk.querySelector('[data-tag]'); if (t) t.textContent = DOORS[door].tag;
      paintText();
      build();
    }
    function wipe(pt, color, mid, done) {
      var w = innerWidth, h = innerHeight;
      var R = Math.hypot(Math.max(pt.x, w - pt.x), Math.max(pt.y, h - pt.y));
      var el = d.createElement('div'); el.className = 'ev2s-wipe';
      el.style.cssText = 'left:' + (pt.x - R) + 'px;top:' + (pt.y - R) + 'px;width:' + (2 * R) + 'px;height:' + (2 * R) + 'px;background:' + color + ';opacity:.9';
      d.body.appendChild(el);
      var a = el.animate([{ transform: 'scale(0)' }, { transform: 'scale(1)' }], { duration: 560, easing: EASE, fill: 'forwards' });
      setTimeout(mid, 330);
      a.onfinish = function () {
        var b = el.animate([{ opacity: .9 }, { opacity: 0 }], { duration: 340, easing: 'ease-out', fill: 'forwards' });
        b.onfinish = function () { el.remove(); if (done) done(); };
      };
    }
    qa('input[name="ev2s-door"]', app).forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (!inp.checked || inp.value === S.door && root.getAttribute('data-ev2-door') === inp.value) return;
        var door = inp.value;
        if (reduce || !el_animate()) { applyDoor(door); return; }
        wipe(origin(inp.parentNode), DOORS[door].paper, function () { applyDoor(door); });
      });
    });
    function el_animate() { return typeof Element !== 'undefined' && Element.prototype.animate; }

    /* ---------- Cor: o respingo nasce do clique e cobre cada peça ---------- */
    var spillT = 0;
    function finishSpill() {
      clearTimeout(spillT);
      qa('.acc > s', desk).forEach(function (s) { s.remove(); });
      desk.style.setProperty('--ev2s-from', S.main);
    }
    function applyColor(inp) {
      var fromPt = origin(inp.parentNode);
      finishSpill();
      S.color = inp.value; S.main = inp.getAttribute('data-main'); S.deep = inp.getAttribute('data-deep'); S.cname = inp.getAttribute('data-name');
      desk.style.setProperty('--ev2s-brand', S.main);
      desk.style.setProperty('--ev2s-deep', S.deep);
      if (colorName) colorName.textContent = S.cname;
      paintText();
      if (reduce || !el_animate()) { finishSpill(); return; }
      qa('.acc', desk).forEach(function (a) {
        var r = a.getBoundingClientRect();
        var ox = fromPt.x - r.left, oy = fromPt.y - r.top;
        var R = Math.hypot(Math.max(Math.abs(ox), Math.abs(r.width - ox)), Math.max(Math.abs(oy), Math.abs(r.height - oy)));
        var s = d.createElement('s');
        s.style.cssText = 'left:' + (ox - R) + 'px;top:' + (oy - R) + 'px;width:' + (2 * R) + 'px;height:' + (2 * R) + 'px';
        a.insertBefore(s, a.firstChild);
        s.animate([{ transform: 'scale(0)' }, { transform: 'scale(1)' }], { duration: 640, easing: EASE, fill: 'forwards' });
      });
      spillT = setTimeout(finishSpill, 700);
    }
    qa('input[name="ev2s-color"]', app).forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) applyColor(inp); });
    });

    /* ---------- Fonte ---------- */
    qa('input[name="ev2s-font"]', app).forEach(function (inp) {
      inp.addEventListener('change', function () { if (!inp.checked) return; S.font = inp.value; desk.setAttribute('data-font', S.font); paintText(); });
    });

    /* ---------- Ponteiro: sombra, brilho e inclinação 3D seguem o ponteiro (variáveis lidas só por transform/translate) ---------- */
    if (!reduce) {
      var tx = .5, ty = .5, raf = 0, pressed = false;
      var apply = function () { raf = 0; desk.style.setProperty('--px', tx.toFixed(3)); desk.style.setProperty('--py', ty.toFixed(3)); };
      var aim = function (x, y) { var r = desk.getBoundingClientRect(); tx = clamp((x - r.left) / r.width, 0, 1); ty = clamp((y - r.top) / r.height, 0, 1); if (!raf) raf = requestAnimationFrame(apply); };
      desk.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') { pressed = true; desk.classList.add('is-aim'); aim(e.clientX, e.clientY); } });
      desk.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch' && !pressed) return; aim(e.clientX, e.clientY); });
      var rest = function () { pressed = false; desk.classList.remove('is-aim'); tx = .5; ty = .5; if (!raf) raf = requestAnimationFrame(apply); };
      desk.addEventListener('pointerleave', rest);
      desk.addEventListener('pointerup', function (e) { if (e.pointerType === 'touch') rest(); });
      desk.addEventListener('pointercancel', rest);
    }

    /* ---------- Levar meu kit: PNG desenhado no canvas ---------- */
    var btn = app.querySelector('[data-ev2s-make-btn]');
    var result = app.querySelector('[data-ev2s-result]');
    var thumb = app.querySelector('[data-ev2s-thumb]');
    var dl = app.querySelector('[data-ev2s-dl]');
    var share = app.querySelector('[data-ev2s-share]');
    var status = app.querySelector('[data-ev2s-status]');
    var url = '', lastFile = null;
    if (btn) btn.addEventListener('click', function () {
      btn.disabled = true;
      makeKit().then(function (blob) {
        if (url) URL.revokeObjectURL(url);
        url = URL.createObjectURL(blob);
        var fname = 'kit-' + (S.name.trim().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'esthetique') + '.png';
        lastFile = typeof File === 'function' ? new File([blob], fname, { type: 'image/png' }) : null;
        thumb.src = url; dl.href = url; dl.setAttribute('download', fname);
        result.hidden = false;
        status.textContent = 'Seu kit está pronto. Se o download não começar, use o link abaixo.';
        if (share) share.hidden = !(lastFile && navigator.canShare && navigator.canShare({ files: [lastFile] }));
        var a = d.createElement('a'); a.href = url; a.download = fname; a.style.display = 'none'; d.body.appendChild(a); a.click(); a.remove();
      }).catch(function () {
        result.hidden = false; status.textContent = 'Não foi possível criar a imagem neste aparelho. Tente de novo.';
      }).then(function () { btn.disabled = false; });
    });
    if (share) share.addEventListener('click', function () {
      if (lastFile && navigator.share) navigator.share({ files: [lastFile], title: 'Meu kit de papelaria' }).catch(function () {});
    });

    /* Desenho do kit. Mesmas peças e mesma composição da mesa; o desenho da ficha vem do recorte do moodboard (ev2-recorte-ficha-*), recolorido na cor escolhida. */
    function makeKit() {
      var cs = getComputedStyle(root);
      var HEAD = (cs.getPropertyValue('--heading-font') || '').trim() || 'Georgia,serif';
      var BODY = (cs.getPropertyValue('--body-font') || '').trim() || 'system-ui,sans-serif';
      var INK = '#2E2127', MUTED = '#6A565D';
      var paper = DOORS[S.door].paper, main = S.main, deep = S.deep;
      var soft = mix(main, '#FFFFFF', .58);
      var moderna = S.font === 'moderna';
      var loads = ['400 40px ' + HEAD, 'italic 400 40px ' + HEAD, '600 20px ' + BODY, '700 20px ' + BODY];
      var fontsReady = d.fonts && d.fonts.load ? Promise.race([Promise.all(loads.map(function (f) { return d.fonts.load(f, 'Aáç'); })), new Promise(function (r) { setTimeout(r, 1500); })]) : Promise.resolve();
      var artUrl = desk.getAttribute('data-art-' + S.door);
      var artLoad = new Promise(function (res) {
        if (!artUrl) return res(null);
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () { res(im); }; im.onerror = function () { res(null); };
        im.src = artUrl;
      });
      return Promise.all([fontsReady, artLoad]).then(function (loaded) {
        var artImg = loaded[1];
        var W = 1080, H = 1350;
        var cv = d.createElement('canvas'); cv.width = W; cv.height = H;
        var c = cv.getContext('2d');
        c.fillStyle = paper; c.fillRect(0, 0, W, H);
        c.globalAlpha = .38; c.fillStyle = main; c.beginPath(); c.arc(960, 110, 300, 0, 7); c.fill();
        c.globalAlpha = .3; c.fillStyle = soft; c.beginPath(); c.arc(80, 1260, 340, 0, 7); c.fill(); c.globalAlpha = 1;

        function ls(v) { if ('letterSpacing' in c) c.letterSpacing = v; }
        function txt(t, x, y, font, color, align) { c.font = font; c.fillStyle = color; c.textAlign = align || 'left'; c.textBaseline = 'middle'; c.fillText(t, x, y); }
        function nameStyle(sz) { return moderna ? { f: '700 ' + (sz * .78) + 'px ' + BODY, up: true, sp: (sz * .09) + 'px' } : { f: '400 ' + sz + 'px ' + HEAD, up: false, sp: '0px' }; }
        function lines(t, sz, maxW, maxLines) {
          var st = nameStyle(sz); if (st.up) t = t.toLocaleUpperCase('pt-BR');
          c.font = st.f; ls(st.sp);
          var words = t.split(' '), out = [], cur = '';
          words.forEach(function (w) {
            var tryS = cur ? cur + ' ' + w : w;
            if (c.measureText(tryS).width <= maxW || !cur) cur = tryS; else { out.push(cur); cur = w; }
          });
          if (cur) out.push(cur);
          out = out.slice(0, maxLines).map(function (l, i, a) {
            if (i === maxLines - 1 && out.length > maxLines) l += '…';
            while (c.measureText(l).width > maxW && l.length > 1) l = l.slice(0, -2) + '…';
            return l;
          });
          return { arr: out, st: st };
        }
        function drawName(t, x, y, sz, maxW, maxLines, color, align) {
          var L = lines(t, sz, maxW, maxLines);
          c.font = L.st.f; ls(L.st.sp); c.fillStyle = color; c.textAlign = align || 'left'; c.textBaseline = 'top';
          L.arr.forEach(function (l, i) { c.fillText(l, x, y + i * sz * 1.18); });
          ls('0px');
        }
        function rr(x, y, w, h, r) { c.beginPath(); if (c.roundRect) c.roundRect(x, y, w, h, r); else c.rect(x, y, w, h); }
        function circle(x, y, r, col) { c.fillStyle = col; c.beginPath(); c.arc(x, y, r, 0, 7); c.fill(); }
        function bar(x, y, w, h, col) { c.fillStyle = col; rr(x, y, w, h, h / 2); c.fill(); }
        function monoAt(x, y, r, bg, ring) {
          circle(x, y, r, bg); if (ring) { c.strokeStyle = 'rgba(46,33,39,.12)'; c.lineWidth = .5; c.beginPath(); c.arc(x, y, r, 0, 7); c.stroke(); }
          txt(mono(), x, y + r * .06, '400 ' + (r * 1) + 'px ' + HEAD, INK, 'center');
        }
        function art(x, y, w) {
          if (!artImg) return;
          var ih = w * 1.1, iw = ih * artImg.width / artImg.height;
          var oc = d.createElement('canvas'); oc.width = artImg.width; oc.height = artImg.height;
          var o = oc.getContext('2d'); o.fillStyle = deep; o.fillRect(0, 0, oc.width, oc.height);
          o.globalCompositeOperation = 'destination-in'; o.drawImage(artImg, 0, 0);
          c.drawImage(oc, x + (w - iw) / 2, y, iw, ih);
        }
        function piece(cx, cy, w, h, rot, draw) {
          var u = w / 100;
          c.save(); c.translate(cx, cy); c.rotate(rot * Math.PI / 180); c.translate(-w / 2, -h / 2);
          c.save(); c.shadowColor = 'rgba(58,40,48,.3)'; c.shadowBlur = w * .12; c.shadowOffsetY = w * .05; c.fillStyle = '#FFFFFF'; rr(0, 0, w, h, w * .032); c.fill(); c.restore();
          c.save(); rr(0, 0, w, h, w * .032); c.clip(); c.scale(u, u); draw(100, h / u); c.restore();
          c.strokeStyle = 'rgba(46,33,39,.09)'; c.lineWidth = 1; rr(.5, .5, w - 1, h - 1, w * .032); c.stroke();
          c.restore();
        }
        var tag = DOORS[S.door].tag, nm = shown();

        // cabeçalho do kit
        ls('4px'); txt('KIT DE PAPELARIA  ·  ESTHÉTIQUE', W / 2, 96, '700 24px ' + BODY, MUTED, 'center'); ls('0px');
        var sz = 100, L;
        for (; sz > 54; sz -= 4) { L = lines(nm, sz, 940, 1); c.font = L.st.f; ls(L.st.sp); var wd = c.measureText(L.arr[0]).width; ls('0px'); if (wd <= 940 && L.arr[0].slice(-1) !== '…') break; }
        drawName(nm, W / 2, 150, sz, 940, 1, deep, 'center');
        txt(tag, W / 2, 150 + sz * 1.18 + 40, 'italic 400 40px ' + HEAD, MUTED, 'center');

        // mesa
        var sx = 40, sy = 340, sw = 1000, sh = 880;
        c.save(); rr(sx, sy, sw, sh, 40); c.clip();
        var g = c.createRadialGradient(sx + sw / 2, sy + sh * .3, 40, sx + sw / 2, sy + sh * .3, sw * .75);
        g.addColorStop(0, 'rgba(255,255,255,.92)'); g.addColorStop(1, mix(main, '#FFFFFF', .62));
        c.fillStyle = g; c.fillRect(sx, sy, sw, sh); c.restore();

        function P(xp, yp, wp, ar) { var w = wp / 100 * sw, h = w / ar; return { x: sx + xp / 100 * sw, y: sy + yp / 100 * sh, w: w, h: h }; }
        var r1 = P(41, 4, 26, 1 / 1.42), f1 = P(3, 10, 36, 1 / 1.32), e1 = P(66, 15, 31, 1.45), k1 = P(40, 60, 46, 1.75);

        piece(r1.x + r1.w / 2, r1.y + r1.h / 2, r1.w, r1.h, 3, function (w, h) { // receituário
          c.fillStyle = soft; c.fillRect(0, 0, w, 21);
          monoAt(16, 10.5, 7, '#FFFFFF', true);
          drawName(nm, 8, 25, 8, 84, 2, deep, 'left');
          txt('Receituário', 8, 46, '700 5.2px ' + BODY, MUTED, 'left');
          bar(8, 53, 84 * .86, 3, soft); bar(8, 60, 84 * .7, 3, soft); bar(8, 67, 84 * .78, 3, soft);
          c.fillStyle = deep; c.globalAlpha = .55; c.fillRect(8, h - 10, 46, .5); c.globalAlpha = 1;
        });
        piece(f1.x + f1.w / 2, f1.y + f1.h / 2, f1.w, f1.h, -4, function (w, h) { // ficha clínica
          monoAt(14, 14, 7, main, true);
          drawName(nm, 25, 8.5, 7.6, 68, 2, deep, 'left');
          txt('Ficha clínica', 7, 34, '700 5.2px ' + BODY, MUTED, 'left');
          art(20, 39, 60);
          bar(7, h - 22, 86 * .78, 3, soft); bar(7, h - 16, 86 * .56, 3, soft);
        });
        piece(e1.x + e1.w / 2, e1.y + e1.h / 2, e1.w, e1.h, 5, function (w, h) { // envelope
          c.fillStyle = soft; c.beginPath(); c.moveTo(0, 0); c.lineTo(100, 0); c.lineTo(50, h * .62); c.closePath(); c.fill();
          circle(50, h * .44, 7.5, main); txt(mono(), 50, h * .44 + .5, '400 7px ' + HEAD, INK, 'center');
          drawName(nm, 50, h - 14, 7.6, 84, 1, deep, 'center');
        });
        piece(k1.x + k1.w / 2, k1.y + k1.h / 2, k1.w, k1.h, -5, function (w, h) { // cartão de visita
          c.fillStyle = main; c.fillRect(0, 0, 6, h);
          monoAt(86, 15, 7, main, true);
          drawName(nm, 12, 9, 8.6, 62, 2, deep, 'left');
          txt(tag, 12, h - 9 - 3, '600 5.2px ' + BODY, MUTED, 'left');
          bar(71, h - 9.5 - 2.6, 22, 2.6, soft);
        });

        txt('Prévia ilustrativa de identidade para clínica de estética.', W / 2, 1288, '500 24px ' + BODY, MUTED, 'center');
        return new Promise(function (res, rej) { cv.toBlob(function (b) { b ? res(b) : rej(new Error('blob')); }, 'image/png'); });
      });
    }
    function mix(a, b, t) {
      function p(h) { h = h.replace('#', ''); return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)]; }
      var A = p(a), B = p(b), o = A.map(function (v, i) { return Math.round(v * (1 - t) + B[i] * t); });
      return 'rgb(' + o.join(',') + ')';
    }
    paintText();
  }

  /* ---------- Cursor: anel que acompanha o ponteiro (só ponteiro fino; o cursor padrão continua visível, inclusive nos campos) ---------- */
  function initCursor() {
    if (!fine || reduce) return;
    var c = d.createElement('div'); c.className = 'ev2s-cursor'; c.setAttribute('aria-hidden', 'true');
    var lab = d.createElement('span'); lab.textContent = 'Ver'; c.appendChild(lab);
    d.body.appendChild(c);
    var x = 0, y = 0, tx = 0, ty = 0, raf = 0, on = false;
    function tick() {
      x += (tx - x) * .24; y += (ty - y) * .24;
      c.style.translate = x.toFixed(1) + 'px ' + y.toFixed(1) + 'px';
      raf = (Math.abs(tx - x) > .3 || Math.abs(ty - y) > .3) ? requestAnimationFrame(tick) : 0;
    }
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY;
      if (!on) { on = true; x = tx; y = ty; c.classList.add('is-on'); }
      var t = e.target && e.target.closest ? e.target : null;
      var field = t && t.closest('input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]),textarea,select,[contenteditable="true"]');
      var card = t && t.closest('.pg-card,.ev2-area');
      var link = t && t.closest('a,button,label,summary,[role="button"]');
      c.classList.toggle('is-field', !!field);
      c.classList.toggle('is-card', !field && !!card);
      c.classList.toggle('is-link', !field && !card && !!link);
      if (!raf) raf = requestAnimationFrame(tick);
    }, { passive: true });
    d.documentElement.addEventListener('mouseleave', function () { on = false; c.classList.remove('is-on'); });
  }
})();
